module.exports = __webpack_public_path__ + "static/media/key.847267bc.svg";